interface DealerLocatorOptionsProps {
  children: React.JSX.Element | React.JSX.Element[];
}

export const DealerLocatorOptions = ({
  children
}: DealerLocatorOptionsProps) => (
  <div className="d-flex align-items-start justify-content-between my-3">
    {children}
  </div>
);
